type DataLayerEvent = Record<string, unknown>;

declare global {
    interface Window {
        dataLayer?: DataLayerEvent[];
    }
}

const GTM_ID = import.meta.env.VITE_APP_GTM_ID;
const GTM_AUTH = import.meta.env.VITE_APP_GTM_AUTH;
const GTM_PREVIEW = import.meta.env.VITE_APP_GTM_PREVIEW;

const environmentParams = () =>
    GTM_AUTH && GTM_PREVIEW
        ? `&gtm_auth=${GTM_AUTH}&gtm_preview=${GTM_PREVIEW}&gtm_cookies_win=x`
        : '';

let inited = false;

export const gtm = {
    load() {
        if (!GTM_ID || inited) return;
        window.dataLayer = window.dataLayer ?? [];
        window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}${environmentParams()}`;
        document.head.appendChild(script);
        inited = true;
    },
    push(event: string, props?: DataLayerEvent) {
        if (!inited) return;
        window.dataLayer?.push({ ...props, event });
    },
};
